import { useEffect, useState } from 'react';
import { KPI } from '@optitrac/components';
import { withAccessControl } from '../pages/service/with-access-control';
import { subSections } from '../pages/utils/constants';
import { getAccessToken } from '../pages/service/accessToken';
import { UserContext } from '../pages/service/userContext';
import { API } from '../pages/service/apiHandler';

type KpiProps = {
  selectedTab: number;
  code: number;
};

type Truck = {
  name: string;
  category?: string;
  categoryCode?: number;
};

type GroupedAsset = {
  categoryCode: number;
  category: string;
  assets: string[];
};

const Kpi = (props: KpiProps) => {
  const [assetCategories, setAssetCategories] = useState<GroupedAsset[]>([]);

  useEffect(() => {
    const isZones = subSections[props.code][props.selectedTab] === 'Zones';
    if (!isZones) return;

    const fetchAssetCategories = async (): Promise<void> => {
      try {
        const response = await API.get('/api/trucks', {
          headers: { Authorization: `Bearer ${getAccessToken()}` },
        });
        const trucks: Truck[] = response.data.data;
        const categories: Map<number, GroupedAsset> = new Map();

        trucks.forEach((truck) => {
          if (truck.categoryCode === undefined || truck.category === undefined)
            return;
          const existing = categories.get(truck.categoryCode);
          if (existing) {
            existing.assets.push(truck.name);
          } else {
            categories.set(truck.categoryCode, {
              categoryCode: truck.categoryCode,
              category: truck.category,
              assets: [truck.name],
            });
          }
        });

        setAssetCategories(Array.from(categories.values()));
      } catch (error) {
        console.log({ error });
      }
    };

    fetchAssetCategories();
  }, [props.code, props.selectedTab]);

  return (
    <KPI
      section={subSections[props.code][props.selectedTab]}
      getAccessToken={getAccessToken}
      UserContext={UserContext}
      API={API}
      assetCategories={assetCategories}
    />
  );
};

export default withAccessControl(Kpi);
